import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@targetStylePath'
import App from './App.jsx'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from '@/queries/client'
import './i18n'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>
)
